import {Link} from 'gatsby'
import React, {useState, useEffect} from 'react'

const preserveList = [
    'utm_medium',
    'utm_source',
    'utm_term',
    'utm_campaign',
    'utm_content',
    'gclid'
]

export const LinkWithUTM = ({to, ...linkProps}) => {
    const [enhancedTo, setEnhancedTo] = useState(to)
    useEffect(() => {
        const currentUrl = new URL(document.location)
        const isHashOnlyLink = typeof to === 'string' && to.startsWith('#')
        const targetUrl = isHashOnlyLink
            ? new URL(`${currentUrl.pathname}${to}`, document.location.origin)
            : new URL(to, document.location.origin)

        const targetSearchParams = Array.from(targetUrl.searchParams.entries())
        const existingSearchParams = Array.from(currentUrl.searchParams.entries())

        const newSearchParams = targetSearchParams.concat(existingSearchParams.filter(([paramName]) => preserveList.includes(paramName)))

        const query = newSearchParams.length > 0
            ? `?${newSearchParams.map(([k, v]) => `${k}=${v}`).join('&')}`
            : ''
        const hash = targetUrl.hash || ''

        setEnhancedTo(`${targetUrl.pathname}${query}${hash}`)
    }, [to])



    return <Link to={enhancedTo} {...linkProps} />
}
